const cache = new Map<string, Intl.PluralRules>();

export function pluralRuleSelect(
    locale: string,
    value: number,
    type: Intl.PluralRuleType = "ordinal"
): Intl.LDMLPluralRule {
    if ("PluralRules" in Intl) {
        const key = "pluralrule$$" + locale + "$$" + type;

        if (cache.has(key)) return cache.get(key).select(value);

        const rule = new Intl.PluralRules(locale, { type });
        cache.set(key, rule);
        return rule.select(value);
    } else {
        // IE11 support
        if (locale === "en-GB") {
            if (value % 10 === 1 && value % 100 !== 11) return "one";
            if (value % 10 === 2 && value % 100 !== 12) return "two";
            if (value % 10 === 3 && value % 100 !== 13) return "few";
        }
        return "other";
    }
}
